var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from '../index.module.scss';
var Video = function (_a) {
    var url = _a.url;
    return (_jsx("div", __assign({ className: styles.entryRoot }, { children: _jsx("video", __assign({ className: styles.attachmentDetails, src: url, controls: true }, { children: _jsx("source", { src: url, type: "video/webm" }, void 0) }), void 0) }), void 0));
};
export default Video;
